(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (function () {
    // Runs once per page regardless of how many rating blocks are on it
    // (a whole collection grid worth, or just one product page). Shopify
    // dedupes {% javascript %} content across repeated block renders, so
    // this executes a single time even with 24 product cards on screen.

    var REVIEWS_IO_STORE = 'teadog.com';
    var ENDPOINT = 'https://api.reviews.io/product/rating-batch';

    function computeStarFill(rating) {
      var decimal = rating % 1;
      var decimalRating = 0;
      if (decimal >= 0.3 && decimal <= 0.7) {
        decimalRating = 0.5;
      } else if (decimal > 0.7) {
        decimalRating = 1;
      }
      var decimalRounded = Math.ceil(decimalRating);
      var filled = Math.floor(rating) + decimalRounded;
      return { filled: filled, decimalRating: decimalRating };
    }

    function applyRating(el, rating, count) {
      var starsStyle = el.getAttribute('data-stars-style');
      var showNumber = el.getAttribute('data-show-number') === 'true';
      var label = el.getAttribute('data-reviews-label') || 'reviews';
      var fill = computeStarFill(rating);

      if (starsStyle === 'single') {
        var singleStar = el.querySelector('.rating .stars');
        if (singleStar) {
          singleStar.classList.toggle('filled-star', fill.filled > 0);
        }
      } else {
        var stars = el.querySelectorAll('.rating .stars');
        stars.forEach(function (starEl, index) {
          var starNumber = index + 1;
          var isFilled = starNumber <= fill.filled;
          starEl.classList.toggle('filled-star', isFilled);

          // First <use> is the fill layer; a second <use> only exists on
          // the "outline" style for the stroke and is left alone.
          var useEl = starEl.querySelector('use');
          if (useEl) {
            if (fill.decimalRating === 0.5 && starNumber === fill.filled) {
              useEl.setAttribute('fill', 'url(#half)');
            } else {
              useEl.removeAttribute('fill');
            }
          }
        });
      }

      var ratingArea = el.querySelector('.rating');
      if (ratingArea) {
        ratingArea.setAttribute('aria-label', rating.toFixed(2) + ' out of 5 stars');
      }

      if (starsStyle === 'single') {
        var valueEl = el.querySelector('.rating-count__value');
        if (valueEl) valueEl.textContent = rating.toFixed(1);
      }

      if (showNumber) {
        var countEl = el.querySelector('.rating-count__count');
        if (countEl) countEl.textContent = count;
        var labelEl = el.querySelector('.rating-count__label');
        if (labelEl) labelEl.textContent = label;
      }

      el.hidden = false;
    }

    function skusForEl(el) {
      var raw = el.getAttribute('data-review-skus') || '';
      return raw.split(';').filter(Boolean);
    }

    // Does the actual fetch + apply for whatever set of blocks it's given.
    // Called on first load with every block on the page, and again later
    // with just whatever new blocks the MutationObserver below finds, so
    // cards injected by filtering, sorting, infinite scroll or quick-add
    // re-renders get picked up without a full page reload.
    function processBlocks(blocks) {
      blocks = blocks.filter(function (el) {
        return !el.hasAttribute('data-review-processed');
      });
      if (!blocks.length) return;

      var allSkus = [];
      blocks.forEach(function (el) {
        el.setAttribute('data-review-processed', '');
        skusForEl(el).forEach(function (sku) {
          if (allSkus.indexOf(sku) === -1) allSkus.push(sku);
        });
      });
      if (!allSkus.length) return;

      var url = ENDPOINT + '?store=' + encodeURIComponent(REVIEWS_IO_STORE)
        + '&sku=' + encodeURIComponent(allSkus.join(';'));

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('bad status ' + res.status);
          return res.json();
        })
        .then(function (entries) {
          if (!Array.isArray(entries) || !entries.length) return;

          blocks.forEach(function (el) {
            var ownSkus = skusForEl(el);
            if (!ownSkus.length) return;

            // An entry belongs to this product if its own sku matches one
            // of ours, OR its "lookup" field (every sku Reviews.io has
            // linked it to) overlaps with ours. This is how a product's
            // reviews get pooled correctly across linked SKUs, e.g. loose
            // vs. bagged versions of the same tea sharing one true count.
            var matched = [];
            var seenSkus = {};
            entries.forEach(function (entry) {
              var lookupSkus = (entry.lookup || '').split(';').filter(Boolean);
              var isMatch = ownSkus.indexOf(entry.sku) !== -1
                || lookupSkus.some(function (s) { return ownSkus.indexOf(s) !== -1; });
              if (isMatch && !seenSkus[entry.sku]) {
                seenSkus[entry.sku] = true;
                matched.push(entry);
              }
            });

            if (!matched.length) return;

            var totalCount = 0;
            var weightedSum = 0;
            matched.forEach(function (entry) {
              var count = parseInt(entry.num_ratings, 10) || 0;
              var avg = parseFloat(entry.average_rating) || 0;
              totalCount += count;
              weightedSum += avg * count;
            });

            if (totalCount <= 0) {
              // Live confirms zero reviews: hide it even if the metafield
              // had rendered something stale-and-visible on first paint.
              el.hidden = true;
              return;
            }

            var combinedRating = weightedSum / totalCount;
            applyRating(el, combinedRating, totalCount);
          });
        })
        .catch(function () {
          // Network hiccup or Reviews.io down: leave whatever was already
          // rendered (stale-but-visible, or hidden) rather than breaking it.
          // Let it be retried later if the observer sees it again attached
          // to a fresh mutation batch, by not leaving the processed marker
          // in place on failure.
          blocks.forEach(function (el) {
            el.removeAttribute('data-review-processed');
          });
        });
    }

    function scan() {
      var blocks = Array.prototype.slice.call(
        document.querySelectorAll('[data-review-rating-block]:not([data-review-processed])')
      );
      if (blocks.length) processBlocks(blocks);
    }

    // Debounced MutationObserver: catches product cards that appear after
    // the initial page load, filter/sort re-renders, infinite scroll,
    // "load more", quick-add duplicating a card, etc. Without this, any
    // card that isn't in the DOM at first run never gets checked and the
    // block just sits on whatever it started with until a full page reload.
    function start() {
      scan();
      var scanTimer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(scanTimer);
        scanTimer = setTimeout(scan, 250);
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Fallback poll: the observer above only fires once DOM mutations on
      // the page go quiet for 250ms. If something else on the page (an app
      // widget, lazy-loaded images, ads, whatever) keeps causing small,
      // unrelated mutations, the debounce keeps getting reset and scan()
      // can end up waiting far longer than it should, confirmed on
      // teadog.com: correct numbers took ~45s to appear on a collection
      // page even though the actual rating-batch fetch resolved in under
      // 50ms once triggered. This runs scan() on a fixed interval too, so
      // the worst case is bounded by POLL_INTERVAL_MS regardless of what
      // else is happening on the page. Capped at POLL_MAX_ATTEMPTS since
      // once every block is processed, scan() is a no-op and further
      // polling is just wasted work.
      var POLL_INTERVAL_MS = 2000;
      var POLL_MAX_ATTEMPTS = 30; // ~60s of coverage at 2s intervals
      var pollAttempts = 0;
      var pollTimer = setInterval(function () {
        pollAttempts++;
        scan();
        if (pollAttempts >= POLL_MAX_ATTEMPTS) clearInterval(pollTimer);
      }, POLL_INTERVAL_MS);
    }

    // document.body may not exist yet depending on exactly when this
    // deferred module executes, so wait for DOMContentLoaded unless the
    // DOM is already parsed.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
